export enum CommissionUnit {
  PERCENT = 'PERCENT',
  MONEY = 'MONEY',
  FIXED = 'FIXED',
}
